import React from 'react';
import './Loader.css';

const Loader = ({ size = 40, message = '' }) => {
  return (
    <div className="loader-container">
      <div
        className="loader-spinner"
        style={{ width: size, height: size }}
        aria-label="Loading"
      />
      {message && <p className="loader-message">{message}</p>}
    </div>
  );
};

export default Loader;
